import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface TargetYearbook {
  name: string;
  api_token: string;
}

export interface TargetYearbookDetaiInfor {
  errors: unknown;
  TargetYearbook: TargetYearbook;
  isAuthenticated: boolean;
}

@Module
export default class TargetYearbookDetail
  extends VuexModule
  implements TargetYearbookDetaiInfor
{
  errors = {};
  TargetYearbook = {} as TargetYearbook;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get TargetYearbookDetail() {
    return this.targetYearbookDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.TARGET_YEARBOOKS_DETAIL_DATA](TargetYearbook) {
    this.targetYearbookDetailData = TargetYearbook;
  }
  @Action
  [Actions.TARGET_YEARBOOK_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/chitieu_niengiam",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.TARGET_YEARBOOKS_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
